// extracted by mini-css-extract-plugin
export default {"gallery":"styles_gallery__8xt6q"};